import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Login from "@/scenes/Login";
import AddWeChat from "@/scenes/AddWeChat";
import WeChatManagement from "@/scenes/WeChatManagement";
import EwaybillAccount from "@/scenes/EwaybillAccount";
import Helper from "@/scenes/Helper";
import ExportEwaybillHistory from "@/scenes/ExportEwaybillHistory";
import EwaybillSearch from "@/scenes/EwaybillSearch";
import ProviderSharedEwaybillAccountPage from "@/scenes/SharedEwaybillAccount/Provider";
import ConsumerSharedEwaybillAccountPage from "@/scenes/SharedEwaybillAccount/Consumer";
import SharedEwaybillAccountRechargeRecords from "@/scenes/SharedRechargeRecords";
import SharedEwaybillProviderDetails from "@/scenes/SharedEwaybillProviderDetails";
import SharedEwaybillConsumerDetails from "@/scenes/SharedEwaybillConsumerDetails";
import BasicLayout from "@/components/BasicLayout";
import ShareRechargeRecordDetailProvider from "@/scenes/ShareRechargeRecordDetail/ShareRechargeRecordDetailProvider";
import ShareRechargeRecordDetailConsumer from "@/scenes/ShareRechargeRecordDetail/ShareRechargeRecordDetailConsumer";
import { Modal } from "antd";
import AuthTokenHolder from "@/services/http/AuthTokenHolder";

interface AppRouteProps {}

interface AdminRouteProps {}

const KEY = "SHOW_H5_TIP_MODAL_KEY";

const AdminRoute: React.FC<AdminRouteProps> = React.memo(function (props) {
  useEffect(() => {
    setTimeout(() => {
      const token = AuthTokenHolder.getToken();

      if (!token) {
        return;
      }

      const flag = localStorage.getItem(KEY);

      if (flag) {
        return;
      }

      Modal.info({
        width: 440,
        title: "电子面单共享平台已支持在手机微信上共享电子面单和增减单号，详细可查看操作流程",
        content: (
          <div>
            <a
              className="mr10"
              target="_blank"
              href="https://qw15p3s8hv.feishu.cn/wiki/GNl0w8kRrilUwLkxvmdcVMZHnve?from=from_copylink"
            >
              如何手机上共享电子面单账号
            </a>
            <a target="_blank" href="https://qw15p3s8hv.feishu.cn/wiki/G1kYwX6iLi5X3ukrJmUc3QcSnKV?from=from_copylink">
              如何在手机上增减单号
            </a>
          </div>
        ),
        closeIcon: true,
        onOk() {
          localStorage.setItem(KEY, "true");
        },
      });
    }, 1500);
  }, []);

  return (
    <BasicLayout>
      <Switch>
        <Route exact path="/ewaybillAccount">
          <EwaybillAccount />
        </Route>
        <Route exact path="/shareEwaybillToOthers">
          <ProviderSharedEwaybillAccountPage />
        </Route>
        <Route
          exact
          path="/shareEwaybillToOthers/details/:ewaybillAccountId/:consumerCompanyId/:logisticsCompany/:sharedShippingAddressesId"
        >
          <SharedEwaybillProviderDetails />
        </Route>
        <Route exact path={["/shareEwaybillToOthers/operationRecord/:id", "/shareEwaybillToMe/operationRecord/:id"]}>
          <SharedEwaybillAccountRechargeRecords />
        </Route>
        <Route exact path="/shareEwaybillToMe">
          <ConsumerSharedEwaybillAccountPage />
        </Route>
        <Route exact path="/shareEwaybillToMe/details/:providerCompanyId/:ewaybillAccountId/:consumerCompanyId">
          <SharedEwaybillConsumerDetails />
        </Route>
        {/* 导出明细记录页面 */}
        <Route exact path="/shareEwaybillToOthers/details/exportEwaybillHistory">
          <ExportEwaybillHistory userType="PROVIDER"></ExportEwaybillHistory>
        </Route>
        <Route exact path="/shareEwaybillToMe/details/exportEwaybillHistory">
          <ExportEwaybillHistory userType="CONSUMER"></ExportEwaybillHistory>
        </Route>
        {/* 充值明细记录页面 */}
        <Route exact path="/shareRechargeRecordDetail/provider">
          <ShareRechargeRecordDetailProvider />
        </Route>
        <Route exact path="/shareRechargeRecordDetail/consumer">
          <ShareRechargeRecordDetailConsumer />
        </Route>
        <Route exact path="/helper">
          <Helper />
        </Route>
        <Route exact path="/ewaybillSearch">
          <EwaybillSearch />
        </Route>
        <Route exact path="/WeChat/management">
          <WeChatManagement />
        </Route>
        <Route path="/WeChat/management/add">
          <AddWeChat />
        </Route>
        <Redirect to="/ewaybillAccount" />
      </Switch>
    </BasicLayout>
  );
});

const AppRoute: React.FC<AppRouteProps> = function (props) {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />

      <AdminRoute />
    </Switch>
  );
};

export default React.memo(AppRoute);
